/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { accountActiveSessions } from '../fn/account/account-active-sessions';
import { AccountActiveSessions$Params } from '../fn/account/account-active-sessions';
import { accountCaptcha } from '../fn/account/account-captcha';
import { AccountCaptcha$Params } from '../fn/account/account-captcha';
import { accountChangePassword } from '../fn/account/account-change-password';
import { AccountChangePassword$Params } from '../fn/account/account-change-password';
import { accountConfirmation } from '../fn/account/account-confirmation';
import { AccountConfirmation$Params } from '../fn/account/account-confirmation';
import { accountForgotPassword } from '../fn/account/account-forgot-password';
import { AccountForgotPassword$Params } from '../fn/account/account-forgot-password';
import { accountGetUserImpersonatedById } from '../fn/account/account-get-user-impersonated-by-id';
import { AccountGetUserImpersonatedById$Params } from '../fn/account/account-get-user-impersonated-by-id';
import { accountGetUserImpersonatedWithPagination } from '../fn/account/account-get-user-impersonated-with-pagination';
import { AccountGetUserImpersonatedWithPagination$Params } from '../fn/account/account-get-user-impersonated-with-pagination';
import { accountGetUserLoginById } from '../fn/account/account-get-user-login-by-id';
import { AccountGetUserLoginById$Params } from '../fn/account/account-get-user-login-by-id';
import { accountGetUserLoginsWithPagination } from '../fn/account/account-get-user-logins-with-pagination';
import { AccountGetUserLoginsWithPagination$Params } from '../fn/account/account-get-user-logins-with-pagination';
import { accountGetUserPasswordHistoryById } from '../fn/account/account-get-user-password-history-by-id';
import { AccountGetUserPasswordHistoryById$Params } from '../fn/account/account-get-user-password-history-by-id';
import { accountGetUserPasswordHistoryWithPagination } from '../fn/account/account-get-user-password-history-with-pagination';
import { AccountGetUserPasswordHistoryWithPagination$Params } from '../fn/account/account-get-user-password-history-with-pagination';
import { accountImpersonateUser } from '../fn/account/account-impersonate-user';
import { AccountImpersonateUser$Params } from '../fn/account/account-impersonate-user';
import { accountLogin } from '../fn/account/account-login';
import { AccountLogin$Params } from '../fn/account/account-login';
import { accountLogout } from '../fn/account/account-logout';
import { AccountLogout$Params } from '../fn/account/account-logout';
import { accountRefreshToken } from '../fn/account/account-refresh-token';
import { AccountRefreshToken$Params } from '../fn/account/account-refresh-token';
import { accountRegister } from '../fn/account/account-register';
import { AccountRegister$Params } from '../fn/account/account-register';
import { accountRegister2 } from '../fn/account/account-register-2';
import { AccountRegister2$Params } from '../fn/account/account-register-2';
import { accountRemoveSession } from '../fn/account/account-remove-session';
import { AccountRemoveSession$Params } from '../fn/account/account-remove-session';
import { accountSendConfirmation } from '../fn/account/account-send-confirmation';
import { AccountSendConfirmation$Params } from '../fn/account/account-send-confirmation';
import { accountStopImpersonation } from '../fn/account/account-stop-impersonation';
import { AccountStopImpersonation$Params } from '../fn/account/account-stop-impersonation';
import { accountUnblock } from '../fn/account/account-unblock';
import { AccountUnblock$Params } from '../fn/account/account-unblock';
import { accountUpdateRefreshToken } from '../fn/account/account-update-refresh-token';
import { AccountUpdateRefreshToken$Params } from '../fn/account/account-update-refresh-token';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfCreateCaptchaDto } from '../models/custom-result-of-create-captcha-dto';
import { CustomResultOfGrowUpTokenDto } from '../models/custom-result-of-grow-up-token-dto';
import { CustomResultOfListOfActiveSessionsDto } from '../models/custom-result-of-list-of-active-sessions-dto';
import { CustomResultOfPaginatedListOfUserImpersonatedWithPaginationDto } from '../models/custom-result-of-paginated-list-of-user-impersonated-with-pagination-dto';
import { CustomResultOfPaginatedListOfUserLoginsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-user-logins-with-pagination-dto';
import { CustomResultOfPaginatedListOfUserPasswordHistoryWithPaginationDto } from '../models/custom-result-of-paginated-list-of-user-password-history-with-pagination-dto';
import { CustomResultOfSecurityTokenDto } from '../models/custom-result-of-security-token-dto';
import { CustomResultOfTwoFactorSecurityTokenDto } from '../models/custom-result-of-two-factor-security-token-dto';
import { CustomResultOfUserImpersonatedByIdDto } from '../models/custom-result-of-user-impersonated-by-id-dto';
import { CustomResultOfUserLoginsByIdDto } from '../models/custom-result-of-user-logins-by-id-dto';
import { CustomResultOfUserPasswordHistoryByIdDto } from '../models/custom-result-of-user-password-history-by-id-dto';

@Injectable({ providedIn: 'root' })
export class AccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accountActiveSessions()` */
  static readonly AccountActiveSessionsPath = '/Account/ActiveSessions';

  /**
   * لیست نشست های فعال کاربر فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountActiveSessions()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountActiveSessions$Response(params?: AccountActiveSessions$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfActiveSessionsDto>> {
    return accountActiveSessions(this.http, this.rootUrl, params, context);
  }

  /**
   * لیست نشست های فعال کاربر فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountActiveSessions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountActiveSessions(params?: AccountActiveSessions$Params, context?: HttpContext): Observable<CustomResultOfListOfActiveSessionsDto> {
    return this.accountActiveSessions$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfActiveSessionsDto>): CustomResultOfListOfActiveSessionsDto => r.body)
    );
  }

  /** Path part for operation `accountRemoveSession()` */
  static readonly AccountRemoveSessionPath = '/Account/RemoveSession';

  /**
   * حذف نشست.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountRemoveSession()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRemoveSession$Response(params: AccountRemoveSession$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return accountRemoveSession(this.http, this.rootUrl, params, context);
  }

  /**
   * حذف نشست.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountRemoveSession$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRemoveSession(params: AccountRemoveSession$Params, context?: HttpContext): Observable<CustomResult> {
    return this.accountRemoveSession$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `accountGetUserImpersonatedWithPagination()` */
  static readonly AccountGetUserImpersonatedWithPaginationPath = '/Account/GetUserImpersonatedWithPagination';

  /**
   * Get User Impersonated with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountGetUserImpersonatedWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountGetUserImpersonatedWithPagination$Response(params: AccountGetUserImpersonatedWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfUserImpersonatedWithPaginationDto>> {
    return accountGetUserImpersonatedWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Impersonated with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountGetUserImpersonatedWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountGetUserImpersonatedWithPagination(params: AccountGetUserImpersonatedWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfUserImpersonatedWithPaginationDto> {
    return this.accountGetUserImpersonatedWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfUserImpersonatedWithPaginationDto>): CustomResultOfPaginatedListOfUserImpersonatedWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `accountGetUserImpersonatedById()` */
  static readonly AccountGetUserImpersonatedByIdPath = '/Account/GetUserImpersonatedById';

  /**
   * Get User Impersonated by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountGetUserImpersonatedById()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountGetUserImpersonatedById$Response(params?: AccountGetUserImpersonatedById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUserImpersonatedByIdDto>> {
    return accountGetUserImpersonatedById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Impersonated by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountGetUserImpersonatedById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountGetUserImpersonatedById(params?: AccountGetUserImpersonatedById$Params, context?: HttpContext): Observable<CustomResultOfUserImpersonatedByIdDto> {
    return this.accountGetUserImpersonatedById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUserImpersonatedByIdDto>): CustomResultOfUserImpersonatedByIdDto => r.body)
    );
  }

  /** Path part for operation `accountGetUserLoginsWithPagination()` */
  static readonly AccountGetUserLoginsWithPaginationPath = '/Account/GetUserLoginsWithPagination';

  /**
   * Get User Logins with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountGetUserLoginsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountGetUserLoginsWithPagination$Response(params: AccountGetUserLoginsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfUserLoginsWithPaginationDto>> {
    return accountGetUserLoginsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Logins with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountGetUserLoginsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountGetUserLoginsWithPagination(params: AccountGetUserLoginsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfUserLoginsWithPaginationDto> {
    return this.accountGetUserLoginsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfUserLoginsWithPaginationDto>): CustomResultOfPaginatedListOfUserLoginsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `accountGetUserLoginById()` */
  static readonly AccountGetUserLoginByIdPath = '/Account/GetUserLoginById';

  /**
   * Get User Login by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountGetUserLoginById()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountGetUserLoginById$Response(params?: AccountGetUserLoginById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUserLoginsByIdDto>> {
    return accountGetUserLoginById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Login by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountGetUserLoginById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountGetUserLoginById(params?: AccountGetUserLoginById$Params, context?: HttpContext): Observable<CustomResultOfUserLoginsByIdDto> {
    return this.accountGetUserLoginById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUserLoginsByIdDto>): CustomResultOfUserLoginsByIdDto => r.body)
    );
  }

  /** Path part for operation `accountGetUserPasswordHistoryWithPagination()` */
  static readonly AccountGetUserPasswordHistoryWithPaginationPath = '/Account/GetUserPasswordHistoryWithPagination';

  /**
   * Get User Logins with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountGetUserPasswordHistoryWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountGetUserPasswordHistoryWithPagination$Response(params: AccountGetUserPasswordHistoryWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfUserPasswordHistoryWithPaginationDto>> {
    return accountGetUserPasswordHistoryWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Logins with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountGetUserPasswordHistoryWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountGetUserPasswordHistoryWithPagination(params: AccountGetUserPasswordHistoryWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfUserPasswordHistoryWithPaginationDto> {
    return this.accountGetUserPasswordHistoryWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfUserPasswordHistoryWithPaginationDto>): CustomResultOfPaginatedListOfUserPasswordHistoryWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `accountGetUserPasswordHistoryById()` */
  static readonly AccountGetUserPasswordHistoryByIdPath = '/Account/GetUserPasswordHistoryById';

  /**
   * Get User Login by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountGetUserPasswordHistoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountGetUserPasswordHistoryById$Response(params?: AccountGetUserPasswordHistoryById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfUserPasswordHistoryByIdDto>> {
    return accountGetUserPasswordHistoryById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get User Login by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountGetUserPasswordHistoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountGetUserPasswordHistoryById(params?: AccountGetUserPasswordHistoryById$Params, context?: HttpContext): Observable<CustomResultOfUserPasswordHistoryByIdDto> {
    return this.accountGetUserPasswordHistoryById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfUserPasswordHistoryByIdDto>): CustomResultOfUserPasswordHistoryByIdDto => r.body)
    );
  }

  /** Path part for operation `accountLogin()` */
  static readonly AccountLoginPath = '/Account/Login';

  /**
   * ورود کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountLogin$Response(params: AccountLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTwoFactorSecurityTokenDto>> {
    return accountLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * ورود کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountLogin(params: AccountLogin$Params, context?: HttpContext): Observable<CustomResultOfTwoFactorSecurityTokenDto> {
    return this.accountLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTwoFactorSecurityTokenDto>): CustomResultOfTwoFactorSecurityTokenDto => r.body)
    );
  }

  /** Path part for operation `accountLogout()` */
  static readonly AccountLogoutPath = '/Account/Logout';

  /**
   * خروج کاربر و حذف نشست فعلی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountLogout()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountLogout$Response(params?: AccountLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return accountLogout(this.http, this.rootUrl, params, context);
  }

  /**
   * خروج کاربر و حذف نشست فعلی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountLogout$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountLogout(params?: AccountLogout$Params, context?: HttpContext): Observable<CustomResult> {
    return this.accountLogout$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `accountConfirmation()` */
  static readonly AccountConfirmationPath = '/Account/Confirmation';

  /**
   * تایید دو مرحله ای.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountConfirmation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountConfirmation$Response(params: AccountConfirmation$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfSecurityTokenDto>> {
    return accountConfirmation(this.http, this.rootUrl, params, context);
  }

  /**
   * تایید دو مرحله ای.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountConfirmation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountConfirmation(params: AccountConfirmation$Params, context?: HttpContext): Observable<CustomResultOfSecurityTokenDto> {
    return this.accountConfirmation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfSecurityTokenDto>): CustomResultOfSecurityTokenDto => r.body)
    );
  }

  /** Path part for operation `accountRefreshToken()` */
  static readonly AccountRefreshTokenPath = '/Account/RefreshToken';

  /**
   * رفرش توکن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountRefreshToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRefreshToken$Response(params: AccountRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfSecurityTokenDto>> {
    return accountRefreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * رفرش توکن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountRefreshToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRefreshToken(params: AccountRefreshToken$Params, context?: HttpContext): Observable<CustomResultOfSecurityTokenDto> {
    return this.accountRefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfSecurityTokenDto>): CustomResultOfSecurityTokenDto => r.body)
    );
  }

  /** Path part for operation `accountUpdateRefreshToken()` */
  static readonly AccountUpdateRefreshTokenPath = '/Account/UpdateRefreshToken';

  /**
   * بروزرسانی رفرش توکن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountUpdateRefreshToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountUpdateRefreshToken$Response(params: AccountUpdateRefreshToken$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGrowUpTokenDto>> {
    return accountUpdateRefreshToken(this.http, this.rootUrl, params, context);
  }

  /**
   * بروزرسانی رفرش توکن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountUpdateRefreshToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountUpdateRefreshToken(params: AccountUpdateRefreshToken$Params, context?: HttpContext): Observable<CustomResultOfGrowUpTokenDto> {
    return this.accountUpdateRefreshToken$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGrowUpTokenDto>): CustomResultOfGrowUpTokenDto => r.body)
    );
  }

  /** Path part for operation `accountRegister()` */
  static readonly AccountRegisterPath = '/Account/Register';

  /**
   * ثبت نام کاربر جدید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRegister$Response(params: AccountRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return accountRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * ثبت نام کاربر جدید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRegister(params: AccountRegister$Params, context?: HttpContext): Observable<CustomResult> {
    return this.accountRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `accountRegister2()` */
  static readonly AccountRegister2Path = '/Account/Register/{planId}';

  /**
   * ثبت نام کاربر جدید همراه شناسه پلن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountRegister2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRegister2$Response(params: AccountRegister2$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfTwoFactorSecurityTokenDto>> {
    return accountRegister2(this.http, this.rootUrl, params, context);
  }

  /**
   * ثبت نام کاربر جدید همراه شناسه پلن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountRegister2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountRegister2(params: AccountRegister2$Params, context?: HttpContext): Observable<CustomResultOfTwoFactorSecurityTokenDto> {
    return this.accountRegister2$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfTwoFactorSecurityTokenDto>): CustomResultOfTwoFactorSecurityTokenDto => r.body)
    );
  }

  /** Path part for operation `accountImpersonateUser()` */
  static readonly AccountImpersonateUserPath = '/Account/ImpersonateUser';

  /**
   * جعل هویت کاربر.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountImpersonateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountImpersonateUser$Response(params: AccountImpersonateUser$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfSecurityTokenDto>> {
    return accountImpersonateUser(this.http, this.rootUrl, params, context);
  }

  /**
   * جعل هویت کاربر.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountImpersonateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountImpersonateUser(params: AccountImpersonateUser$Params, context?: HttpContext): Observable<CustomResultOfSecurityTokenDto> {
    return this.accountImpersonateUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfSecurityTokenDto>): CustomResultOfSecurityTokenDto => r.body)
    );
  }

  /** Path part for operation `accountStopImpersonation()` */
  static readonly AccountStopImpersonationPath = '/Account/StopImpersonation';

  /**
   * توقف جعل هویت.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountStopImpersonation()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountStopImpersonation$Response(params?: AccountStopImpersonation$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfSecurityTokenDto>> {
    return accountStopImpersonation(this.http, this.rootUrl, params, context);
  }

  /**
   * توقف جعل هویت.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountStopImpersonation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountStopImpersonation(params?: AccountStopImpersonation$Params, context?: HttpContext): Observable<CustomResultOfSecurityTokenDto> {
    return this.accountStopImpersonation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfSecurityTokenDto>): CustomResultOfSecurityTokenDto => r.body)
    );
  }

  /** Path part for operation `accountSendConfirmation()` */
  static readonly AccountSendConfirmationPath = '/Account/SendConfirmation';

  /**
   * ارسال کد تایید.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountSendConfirmation()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountSendConfirmation$Response(params?: AccountSendConfirmation$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return accountSendConfirmation(this.http, this.rootUrl, params, context);
  }

  /**
   * ارسال کد تایید.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountSendConfirmation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountSendConfirmation(params?: AccountSendConfirmation$Params, context?: HttpContext): Observable<CustomResult> {
    return this.accountSendConfirmation$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `accountForgotPassword()` */
  static readonly AccountForgotPasswordPath = '/Account/ForgotPassword';

  /**
   * فراموشی کلمه عبور.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountForgotPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountForgotPassword$Response(params: AccountForgotPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return accountForgotPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * فراموشی کلمه عبور.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountForgotPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountForgotPassword(params: AccountForgotPassword$Params, context?: HttpContext): Observable<CustomResult> {
    return this.accountForgotPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `accountChangePassword()` */
  static readonly AccountChangePasswordPath = '/Account/ChangePassword';

  /**
   * تغییر کلمه عبور.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountChangePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountChangePassword$Response(params: AccountChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return accountChangePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * تغییر کلمه عبور.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountChangePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountChangePassword(params: AccountChangePassword$Params, context?: HttpContext): Observable<CustomResult> {
    return this.accountChangePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `accountCaptcha()` */
  static readonly AccountCaptchaPath = '/Account/Captcha';

  /**
   * تولید تصویر کپچا.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountCaptcha()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountCaptcha$Response(params?: AccountCaptcha$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfCreateCaptchaDto>> {
    return accountCaptcha(this.http, this.rootUrl, params, context);
  }

  /**
   * تولید تصویر کپچا.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountCaptcha$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountCaptcha(params?: AccountCaptcha$Params, context?: HttpContext): Observable<CustomResultOfCreateCaptchaDto> {
    return this.accountCaptcha$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfCreateCaptchaDto>): CustomResultOfCreateCaptchaDto => r.body)
    );
  }

  /** Path part for operation `accountUnblock()` */
  static readonly AccountUnblockPath = '/Account/Unblock';

  /**
   * رفع انسداد کاربر مسدود شده هنگام لاگین.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountUnblock()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountUnblock$Response(params: AccountUnblock$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return accountUnblock(this.http, this.rootUrl, params, context);
  }

  /**
   * رفع انسداد کاربر مسدود شده هنگام لاگین.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountUnblock$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountUnblock(params: AccountUnblock$Params, context?: HttpContext): Observable<CustomResult> {
    return this.accountUnblock$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
